import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Navbar from '../navbar/Navbar';
import "./development.css";
import Formpage from '../Formpage/Formpage';
import AOS from 'aos';
import 'aos/dist/aos.css';

const items = [
    {
        title: 'BASIC WEBSITE',
        description: [
            'Up to 5 Web Pages',
            'Modern & Responsive Design',
            '1 Month Free Support',
            'WhatsApp Chat Integration',
            'Google Maps Embedding',
            'Contact Form Integration',
            '3 E-Mail business id',
        ],
    },
    {
        title: 'STANDARD WEBSITE',
        description: [
            'Up to 12 Custom Pages',
            'Modern & Responsive Design',
            'Interactive Contact Form',
            'WhatsApp Chat Button & Integration',
            'Social Media Integration',
            'Google Maps Integration',
            'Free Support for 3 Months',
            '5 Mail IDs for Business',
        ],
    },
    {
        title: 'ADVANCED WEBSITE',
        description: [
            'Up to 12+ Custom Pages',
            'Premium, Mobile-Responsive Design',
            'Custom Animations & UI Enhancements',
            'Advanced Contact Forms with Filters',
            'WhatsApp Chat + Live Chat Integration',
            'Google Maps & Location Features',
            'Social Media Feeds & Share Buttons',
            'Domain & Hosting',
            '6 Month Free Support',
        ],
    },
    {
        title: 'CMS BASED WEBSITE',
        description: [
            'Fully Custom CMS Website',
            'Up to 20 Pages with Dynamic Content',
            'Premium, Mobile-Responsive Design',
            'Custom Animations & UI Enhancements',
            'Advanced Forms & Integrations',
            'WhatsApp Chat, Live Chat & Google Maps',
            'Social Media Feeds & Share Buttons',
            'Hosting & Domain Setup',
            'E-commerce Module',
            'API & Third-Party Integrations',
            '6 Month Free Support',
        ],
    },
];

function Web() {
    const [show, setShow] = useState(false);
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        centerMode: true,
        centerPadding: '0px',
        arrows: true,
        initialSlide: 0,

        responsive: [
            {
                breakpoint: 992, // tablet and below
                settings: {
                    slidesToShow: 2,
                    arrows: false,
                    centerMode: false
                }
            },
            {
                breakpoint: 576, // mobile
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                    centerMode: false
                }
            }
        ]
    };

    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
        });

        setTimeout(() => {
            AOS.refresh();
        }, 500);
    }, []);



    return (
        <>
            <Navbar />
            <div className="container-fluid web-container" >


                <div className="wrapper">
                    <section className='section-margin'>
                        <center>
                            <div className='heading-for-all' data-aos="fade-up">
                                <h2>Web development</h2>
                            </div>
                        </center>
                    </section>

                    <Slider {...settings} className="news-slider">
                        {items.map((item, index) => (
                            <div className="news-slider__item" key={index}
                            >
                                <div className="news__item news__itemweb" data-aos="fade-up"
                                    data-aos-delay="1000">
                                    <div className="news__title">{item.title}</div>
                                    <ul className="news__txt">
                                        {item.description.map((point, idx) => (
                                            <li key={idx}>{point}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </Slider>

                </div>

                <div
                    className="container d-flex justify-content-center my-4"
                    data-aos="fade-up"
                    data-aos-delay="1000"
                >
                    <button className="btn-15" onClick={handleShow}>
                        Get Enquiry
                    </button>
                </div>

            </div>

            <Formpage show={show} onClose={handleClose} />
        </>
    );
}

export default Web;
